import { gql } from '@apollo/client';

export const CREATE_TALENT_INVITE_LINK_FOR_CAMPAIGN = gql`
  mutation CreateTalentInviteLinkForCampaign(
    $input: CreateTalentInviteLinkForCampaignInput!
  ) {
    createTalentInviteLinkForCampaign(input: $input) {
      id
      type
      code
    }
  }
`;

export const CREATE_TALENT_INVITE_LINK_ALL_DEALS = gql`
  mutation CreateTalentInviteLinkAllDeals(
    $input: CreateTalentInviteLinkAllDealsInput!
  ) {
    createTalentInviteLinkAllDeals(input: $input) {
      id
      type
      code
    }
  }
`;

export const DEACTIVATE_TALENT_INVITE_LINK = gql`
  mutation DeactivateTalentInviteLink(
    $input: DeactivateTalentInviteLinkInput!
  ) {
    deactivateTalentInviteLink(input: $input)
  }
`;
